export default __webpack_public_path__ + "static/media/02.1bddf9d7.jpg";